module.exports = __webpack_public_path__ + "img/lock.31e62ff9.svg";